import electronUtils from 'utils/electronUtils';

export default class Settings {
  static getBasePath() {
    const debug = this.debugMode();
    let url = this.livePath();

    if (electronUtils.isElectron()) {
      url = `${__dirname}${this.debugPath()}`;
    }

    if (debug) {
      url = this.debugPath();

      if (electronUtils.isElectron()) {
        url = `${__dirname}${this.debugPath()}`;
      }
    }
    return url;
  }

  static debugMode() {
    // WHen prod build set this to false and add /xperience/ in urls to files in index.html. In dist folder.
    let v = true;
    if (process.env.REACT_APP_DEBUG_MODE === 'true') {
      v = true;
    } else {
      v = false;
    }
    return v;
  }

  static livePath() {
    return process.env.REACT_APP_ASSET_PROD_PATH;
  }

  static debugPath() {
    return process.env.REACT_APP_ASSET_DEBUG_PATH;
  }

  static ufApiKey() {
    return process.env.REACT_APP_DEV_UMBRACO_FORM_API_KEY;
  }
}
